import { ethers } from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { LPXLibProfit_v1ABI } from "./abi/LPXLibProfit_v1ABI";
import { LPXShareInfo } from "./LPXContract";

export class LPXLibProfitShareInfo{
    public shareInfo_:LPXShareInfo;
    public pps_:bigint;
}

export class LPXLibProfitContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, LPXLibProfit_v1ABI.GetABI(), provider);
    }


//getShareInfo(uint256 poolId_, address user_) external view returns(ILPXv1.ShareInfo memory shareInfo_, uint256 pps_);
    async getShareInfo(poolId:number, forAddress:string):Promise<LPXLibProfitShareInfo>
    {
        const response = await this._call("getShareInfo", poolId, forAddress);
        if (!response) return;
        const result = new LPXLibProfitShareInfo();
        result.pps_ = response.pps_;
        result.shareInfo_ = new LPXShareInfo();
        result.shareInfo_.debt = response.shareInfo_.debt;
        result.shareInfo_.pending = response.shareInfo_.pending;
        return result;
    }
}